import { Calendar, Mail, MessageSquare } from 'lucide-react';

// Generic portal landing — shown for both the bare /portal index and any
// session-expired redirect. Magic-link access only, so the message stays
// neutral: "use your link to come in".
export const Index = () => (
  <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 via-white to-teamcare-blue/5 px-4 py-12">
    <div className="w-full max-w-md">
      <div className="relative bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
        <div
          aria-hidden="true"
          className="h-1 bg-gradient-to-r from-teamcare-blue to-teamcare-cyan"
        />
        <div className="p-8 text-center">
          <div className="flex justify-center mb-5">
            <div className="relative">
              <div
                aria-hidden="true"
                className="absolute inset-0 bg-teamcare-blue/25 rounded-2xl blur-xl"
              />
              <div className="relative w-16 h-16 bg-gradient-to-br from-teamcare-blue to-teamcare-blue-dark rounded-2xl flex items-center justify-center shadow-lg shadow-blue-200/60">
                <Calendar size={28} className="text-white" strokeWidth={2.25} />
              </div>
            </div>
          </div>

          <h1 className="text-2xl font-bold text-secondary-900 mb-2">
            Patient Portal
          </h1>
          <p className="text-sm text-secondary-500 leading-relaxed mb-6">
            Visit the link your dental office sent you to access your portal.
          </p>

          <ul className="space-y-2 text-left">
            <li className="flex items-center gap-3 bg-gray-50 rounded-lg p-3 border border-gray-200">
              <div className="w-9 h-9 rounded-lg bg-white border border-gray-200 flex items-center justify-center shrink-0">
                <MessageSquare size={15} className="text-teamcare-blue" />
              </div>
              <div>
                <p className="text-sm font-semibold text-secondary-900">
                  Check your text messages
                </p>
                <p className="text-xs text-secondary-500 leading-snug">
                  Look for a recent SMS from your dental office.
                </p>
              </div>
            </li>
            <li className="flex items-center gap-3 bg-gray-50 rounded-lg p-3 border border-gray-200">
              <div className="w-9 h-9 rounded-lg bg-white border border-gray-200 flex items-center justify-center shrink-0">
                <Mail size={15} className="text-teamcare-blue" />
              </div>
              <div>
                <p className="text-sm font-semibold text-secondary-900">
                  Or check your email
                </p>
                <p className="text-xs text-secondary-500 leading-snug">
                  The link may also have been sent there.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <p className="text-center text-xs text-secondary-400 mt-5">
        Can't find the link? Contact your dental office for a new one.
      </p>
    </div>
  </div>
);
